<div class="sir-hero-media">
    @switch (mediaItem.type) {
        <!-- @case ('image') {
            <sirius-image-item [image]="mediaItem | cast" [sizes]="sizes" [fit]="'cover'"></sirius-image-item>
        } -->
        @case ('video') {
            <sirius-video-item [video]="mediaItem | cast"></sirius-video-item>
        }
    }
</div>
@if (hasContent()) {
    <sirius-grid>
        <div class="sir-box">
            <div class="sir-text">
                <sirius-heading [text]="title" textStyleCategory="title" textStyleSize="s"></sirius-heading>
                <!-- TODO: Replace with sirius-text-html-paragraph -->
                <div class="sir-text-style-paragraph-m-default" [innerHtml]="textHtml"></div>
            </div>
            @if (button) {
                <a
                    siriusButton
                    [siriusLink]="button.link"
                    [iconName]="button.iconName"
                    [buttonText]="button.link.title"
                    [buttonType]="'primary'">
                </a>
            }
        </div>
    </sirius-grid>
}
